module.exports = __webpack_public_path__ + "static/media/kitchen2.d890a0f0.jpg";